import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { createSingleInterpolatedTranslationKey, createTranslatedText, TranslatableText } from '@dreryk/react-common';

import { translationKeys } from './translations';

export const getPatientReferenceIdentifierTranslatableText = (
   referenceIdentifier: PatientReferenceIdentifier | undefined,
   fallbackText?: TranslatableText
): TranslatableText => {
   if (!referenceIdentifier) {
      return fallbackText ?? createTranslatedText('-');
   }

   const externalIdentifier = referenceIdentifier.findExternalIdentifier();
   if (externalIdentifier) {
      return externalIdentifier.accept({
         visitPesel: (pesel) =>
            createSingleInterpolatedTranslationKey(translationKeys.pesel, 'peselVal', pesel.asString()),
         visitGuardianPesel: (guardianPesel) =>
            createSingleInterpolatedTranslationKey(
               translationKeys.guardianPesel,
               'guardianPesel',
               guardianPesel.asString()
            ),
         visitPassport: (passport) =>
            createSingleInterpolatedTranslationKey(translationKeys.passport, 'passport', passport.getValue()),
         visitNationalIdentificationNumber: (nationalIdentificationNumber) =>
            createSingleInterpolatedTranslationKey(
               translationKeys.pinue,
               'nationalIdentificationNumber',
               nationalIdentificationNumber.getValue()
            ),
      });
   }

   const medicalRecordNumber = referenceIdentifier.findMedicalRecordNumber();
   if (medicalRecordNumber) {
      return createSingleInterpolatedTranslationKey(
         translationKeys.medicalRecordNumber,
         'medicalRecordNumber',
         medicalRecordNumber.asString()
      );
   }

   return fallbackText ?? createTranslatedText('-');
};
